module.exports = __webpack_public_path__ + "img/face4.d5afaa66.jpg";